// extracted by mini-css-extract-plugin
export default {"header":"ExplanationBullets--header--dacee6","container":"ExplanationBullets--container--956c00"};